import Cookie from 'js-cookie';
import Analytics from './analytics';
import {constants} from './constant';

const UTILS = {
    getCookieObject: function() {
		var country = Cookie.get(constants.countryCookie);
		var consent = Cookie.get(constants.consentCookie)

		let countrySet = country != undefined ? country.split("|") : "";

		// to tired to improve this
		return {
			"country": (countrySet[0])?(countrySet[0]):undefined,
			"countryCode": (countrySet[1])?(countrySet[1]):undefined,
			"region": (countrySet[2])?(countrySet[2]):undefined,
			"investType": (countrySet[3])?(countrySet[3]):undefined,
			"consent": consent
		}
	},
	// Debounce is part of Underscore.js 1.5.2 http://underscorejs.org
	// (c) 2009-2013 Jeremy Ashkenas. Distributed under the MIT license.
	debounce: function (func, wait=500, immediate=false) {
		// Returns a function, that, as long as it continues to be invoked,
		// will not be triggered. The function will be called after it stops
		// being called for N milliseconds. If `immediate` is passed,
		// trigger the function on the leading edge, instead of the trailing.
		var result;
		var timeout = null;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) { result = func.apply(context, args); }
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) { result = func.apply(context, args); }
			return result;
		};
	},
	setSessionStorage: function(key, value) {
		sessionStorage.setItem(key, value);
	},
	getSessionStorage: function(key) {
		return sessionStorage.getItem(key);
	},
	setFrameHeight : function() {
		// below assume only fund info iframe per page
		window.addEventListener('message', function (event) {
			var isObj = event.data instanceof Object;
			var isArr = event.data instanceof Array;

			if ((!isArr && !isObj)) {
				try {
					var iFrameData = JSON.parse(event.data);
				} catch(e) { }

				if (iFrameData && iFrameData.type == "IFrameSize") {
					var iframeId = document.querySelector(".funds_iframe");

					if(iframeId) {
						iframeId.height = iFrameData.data.Height;
					}
				}
			}
		})
	},
	getCountryLanguage: function(countryCode) {
		if(countryCode) {
			let countryItem = document.querySelector(`[data-country-code=${countryCode}]`);
			return countryItem.dataset.countryLanguage;
		}
		return "";
	},

	addQueryParam: function(key, value) {
		const url = new URL(window.location.href);
		url.searchParams.set(key, value);
		window.history.pushState({}, '', url.toString());
	},

	getQueryParam: function(key) {
		const url = new URL(window.location.href);
		return url.searchParams.get(key) || '';
	},

	// This function has a copy in static folder  - src/static/forms/gtm-script.js
	// Please make sure you update it at both location if you have to update this
    getSiteSections: function() {
		const site_url = window.location.pathname;
		const pathArray = site_url.split('/').filter(elm => elm);
		const conditions = ["institutional", "wholesale"];
		const elIndexes = conditions.map(el => pathArray.indexOf(el));
		let primary_site_section, site_section, page_section = '';

		elIndexes.includes(1) ?
			primary_site_section = (pathArray[2] !== undefined ? pathArray[2] : "Not Applicable") :
			primary_site_section = (pathArray[1] !== undefined ? pathArray[1] : "Not Applicable");
		elIndexes.includes(1) ?
			site_section = (pathArray[3] !== undefined ? pathArray[3] : "Not Applicable") :
			site_section = (pathArray[2] !== undefined ? pathArray[2] : "Not Applicable");
		elIndexes.includes(1) ?
			page_section = (pathArray[4] !== undefined ? pathArray[4] : "Not Applicable") :
			page_section = (pathArray[3] !== undefined ? pathArray[3] : "Not Applicable");


		const investor_type = UTILS.getCookieObject().investType ?? "NA Applicable";

		const siteSections = {
			primary_site_section: primary_site_section,
			secondary_site_section: site_section,
			page_section: page_section,
			investor_type: investor_type,
		}

        return siteSections;
    },
};

//event listener for podcast data analytics
window.addEventListener('message', function (e) {
	if (e.origin == "https://www.buzzsprout.com") {
		let eventObj = Analytics.getAnalyticsObjectFor('podcastclick');
		eventObj.event = "podcast_interaction"
		eventObj.action_type = e.data.name;
		eventObj.media_id = e.data.episode_id;
		eventObj.media_length = e.data.duration ? e.data.duration : '' ;
		Analytics.pushToAnalytics(JSON.parse(eventObj));
	}
});

window.addEventListener('load', () => {
	const el = document.querySelector('.search-result-data');
	if(el !== null && el !== undefined) {
		const analyticsData = el.dataset?.analytics;
		analyticsData !== undefined ? Analytics.pushToAnalytics(JSON.parse(analyticsData)) : null;
	}
});

window.addEventListener('load', () => {
	const bbRichText = [...(document.querySelectorAll('.bb-rich-text'))];
	bbRichText.forEach((el)=>{
		[...(el.querySelectorAll('a.pdf-link'))].forEach( el => el.parentElement.classList.add('pdf-link-wrapper'));
	});
})

export default UTILS;
